var map = {
	"./clock.svg": 492,
	"./community.svg": 493,
	"./cube.svg": 494,
	"./education.svg": 495,
	"./facebook.svg": 496,
	"./initial-exam.svg": 497,
	"./instagram.svg": 498,
	"./knowledge.svg": 499,
	"./location-01.svg": 500,
	"./personal.svg": 501,
	"./phone-01.svg": 502,
	"./smiley-face.svg": 503,
	"./snapchat.svg": 504,
	"./sponsorship.svg": 505
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 561;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 561
// module chunks = 1